<script setup>
import { onMounted } from "vue";
import { openApp } from "@/utils/appLink";
import WxLaunchAppBtn from "./WxLaunchAppBtn.vue";

const { appParams } = defineProps(["appParams"]);

const handleToApp = (params = {}) => {
  openApp(params);
};

defineExpose({
  handleToApp,
});

onMounted(() => {});
</script>

<template>
  <div class="box" id="wakeup-btn">
    <button
      class="text"
      style="
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        outline: none;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
      "
    >
      在APP中打开
      <!-- <WxLaunchAppBtn :appParams="appParams" /> -->
    </button>
  </div>
</template>

<style lang="scss" scoped>
.box {
  position: fixed;
  bottom: calc(8px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  width: 187px;
  height: 61px;
  background: url("@/assets/app-tips.png") no-repeat;
  background-size: 100% 100%;
}
.text {
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  color: #fff;
  position: absolute;
  right: 32px;
  top: 10px;
}
</style>
